export const SET_RENTAL_PLAN_INDEX = 'SET_RENTAL_PLAN_INDEX';
export const GET_RENTAL_PLAN_ABTEST = 'GET_RENTAL_PLAN_ABTEST';
export const GET_RENTAL_PLAN_ABTEST_SUCCESS = 'GET_RENTAL_PLAN_ABTEST_SUCCESS';
export const GET_RENTAL_PLAN_ABTEST_ERROR = 'GET_RENTAL_PLAN_ABTEST_ERROR';
